import {listEndpoint, type ListEndpoint} from "./util/ListEndpoint.ts";
import {type MetlApiQueryApi, metlApiQueryEndpoint} from "./MetlApiQueryApi.tsx";
import type { MetlCredentialExport } from "../metl-models/exports/MetlCredentialExport.ts";
import type {AxiosInstance} from "axios";

export interface TypedMetlCredential {
    name: string
    type: string
}

export interface MetlCredentialsApi {
    aws: ListEndpoint<MetlApiQueryApi, MetlCredentialExport>
    gcp: ListEndpoint<MetlApiQueryApi, MetlCredentialExport>
    azure: ListEndpoint<MetlApiQueryApi, MetlCredentialExport>
}

export function metlCredentialsApi(axios: AxiosInstance, baseUrl: string, id: string): MetlCredentialsApi {
    return {
        aws: listEndpoint(axios, `${baseUrl}/aws`, `${id}/aws`, metlApiQueryEndpoint),
        gcp: listEndpoint(axios, `${baseUrl}/gcp`, `${id}/gcp`, metlApiQueryEndpoint),
        azure: listEndpoint(axios, `${baseUrl}/azure`, `${id}/azure`, metlApiQueryEndpoint)
    }
}